import React from 'react';
import Img01 from '../assets/ourUser/img01.jpg';
import Img02 from '../assets/ourUser/img02.jpg';
import Img03 from '../assets/ourUser/img03.jpg';
import Img04 from '../assets/ourUser/img04.jpg';
import Img05 from '../assets/ourUser/img05.jpg';
import Img06 from '../assets/ourUser/img06.jpg';
import Img07 from '../assets/ourUser/img07.jpg';
import Img08 from '../assets/ourUser/img08.jpg';
import Img09 from '../assets/ourUser/img09.jpg';
import Img10 from '../assets/ourUser/img10.jpg';
import Img11 from '../assets/ourUser/img11.jpg';
import Img12 from '../assets/ourUser/img12.jpg';
import Img13 from '../assets/ourUser/img13.jpg';

const testimonials = [
    {
        id: 1,
        name: "All Students",
        course: "Finde better Engineering collage through ACA",
        // rank: "",
        image: Img01,
        testimonial: "The counseling sessions helped me understand my strengths and choose the right branch. Now I'm at IIT Bombay!"
    },
    {
        id: 2,
        name: "Priya Singh",
        course: "12th PCM",
        percentage: "95%",
        image: Img02,
        testimonial: "Thanks to ACA's guidance, I scored 95% in boards and got into my dream college."
    },
    {
        id: 3,
        name: "Amit Sharma",
        course: "JEE Mains",
        rank: "AIR 5678",
        image: Img03,
        testimonial: "The structured approach and mock tests at ACA were crucial for my JEE preparation."
    },
    {
        id: 4,
        name: "Satendra Patel",
        course: "12th PCB",
        percentage: "97%",
        image: Img04,
        testimonial: "ACA's biology experts helped me secure top marks and get into AIIMS."
    },
    {
        id: 5,
        name: "Arun kumar",
        course: "10th Science",
        rank: "AIR 2345",
        image: Img05,
        testimonial: "The personal mentoring and doubt-clearing sessions made complex topics easy to understand."
    },
    {
        id: 6,
        name: "Rohit Gupta",
        course: "12th Commerce",
        percentage: "96%",
        image: Img06,
        testimonial: "ACA's commerce faculty helped me excel in accounts and economics."
    },
    {
        id: 7,
        name: "Karan Malhotra",
        course: "JEE Mains",
        rank: "AIR 3456",
        image: Img07,
        testimonial: "The weekly tests and performance analysis helped me improve consistently."
    },
    {
        id: 8,
        name: "Ananya Desai",
        course: "12th PCM",
        percentage: "94%",
        image: Img08,
        testimonial: "Perfect balance of theory and numerical problem-solving helped me score well."
    },
    {
        id: 9,
        name: "Rajesh Kumar",
        course: "JEE Advanced",
        rank: "AIR 4567",
        image: Img09,
        testimonial: "The advanced problem-solving techniques taught at ACA were game-changers."
    },
    {
        id: 10,
        name: "Meera Verma",
        course: "12th PCB",
        percentage: "97%",
        image: Img10,
        testimonial: "Comprehensive study material and regular tests helped me achieve my target."
    },
    {
        id: 11,
        name: "Vikram Singh",
        course: "JEE Mains",
        rank: "AIR 6789",
        image: Img11,
        testimonial: "The stress management sessions along with academic guidance were invaluable."
    },
    {
        id: 12,
        name: "Riya Kapoor",
        course: "12th Commerce",
        percentage: "93%",
        image: Img12,
        testimonial: "ACA's practical approach to commerce subjects helped me understand market concepts better."
    },
    {
        id: 13,
        name: "Aryan Gupta",
        course: "JEE Advanced",
        rank: "AIR 7890",
        image: Img13,
        testimonial: "The mock tests and feedback sessions helped me identify my strengths and weaknesses."
    }
]

export default testimonials;